module.exports = {"231226001":"车站街道","231226002":"建设街道","231226003":"西北街道","231226004":"东南街道","231226100":"绥棱镇","231226101":"上集镇","231226102":"四海店镇","231226103":"双岔河镇","231226104":"阁山镇","231226105":"长山镇","231226200":"靠山乡","231226201":"后头乡","231226205":"克音河乡","231226206":"绥中乡","231226207":"泥尔河乡","231226400":"绥棱县国有林场阁山林场","231226401":"绥棱县国有林场四海店林场","231226402":"绥棱县国有林场三吉台林场","231226403":"绥棱县国有林场半截河林场","231226404":"黑龙江省绥棱林业局有限公司","231226500":"黑龙江北大荒农垦集团绥棱农场有限公司","231226580":"种马场","231226581":"良种场","231226582":"绥棱县猪场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231226.json
// module id = 895
// module chunks = 0